import React, { memo } from 'react';
import { ReactSelectComponents } from '@Sage/hoi-poi-ui';

import WarningPopoverIcon from './WarningPopoverIcon';

const UomSingleValue = memo(function UomSingleValue({ lineUomInactive, ...props }) {
    const { data } = props;
    const showInactiveWarning = lineUomInactive || data?.__isInactive;
    if (!showInactiveWarning) {
        return (
            <ReactSelectComponents.SingleValue {...props}>
                <span>{data?.label}</span>
            </ReactSelectComponents.SingleValue>
        );
    }
    return (
        <ReactSelectComponents.SingleValue {...props}>
            <span className="fm-uom-cell__selected-inactive">
                <span className="fm-uom-cell__selected-inactive-label">{data?.label}</span>
                <WarningPopoverIcon />
            </span>
        </ReactSelectComponents.SingleValue>
    );
});

export default UomSingleValue;
